var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnotationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34137 0.612244C1.91958 0.612244 1.51506 0.777209 1.21681 1.07085C0.918563 1.36449 0.751007 1.76275 0.751007 2.17802L0.751006 8.06534C0.751006 8.48061 0.918562 8.87887 1.21681 9.17251C1.51506 9.46615 1.91958 9.63111 2.34137 9.63111L5.84017 9.63111L5.84017 7.1885C5.84017 6.77323 6.00772 6.37497 6.30597 6.08133C6.60423 5.78769 7.00874 5.62273 7.43053 5.62273L9.9115 5.62273L9.9115 2.17802C9.9115 1.76275 9.74394 1.36449 9.44569 1.07085C9.14744 0.77721 8.74293 0.612244 8.32114 0.612244L2.34137 0.612244ZM9.77078 6.24904L7.43053 6.24904C7.17746 6.24904 6.93475 6.34802 6.7558 6.5242C6.57685 6.70038 6.47631 6.93934 6.47631 7.1885L6.47631 9.49257C6.65142 9.4147 6.81074 9.30622 6.94655 9.1724L9.44558 6.71226C9.58153 6.57847 9.69171 6.42152 9.77078 6.24904Z",
    fill: "#F1C04F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationIcon);
export default __webpack_public_path__ + "static/media/annotation_icon.8ead5ae8f17b9a77689d41a7c08ec6b8.svg";
export { ForwardRef as ReactComponent };